import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

import { PackWrapper } from './style';
import ProgressBar from '../progressBar';

const PackCard = ({ cardsData, activeShipmentIndex, setActiveShipmentIndex }) => {
  const [isSelected, setIsSelected] = useState(false);

  const {
    fetchingWarehouseShipments,
    settingPackInformation,
  } = useSelector((state) => state.postShipment || {});

  return (
    <Spin tip='Loading...' spinning={settingPackInformation}>
      <PackWrapper
        className={isSelected ? 'border-active' : ''}
        onClick={() => setIsSelected(true)}
      >
        {cardsData?.map((item, index) => (
          <div
            key={item.id}
            className={`item-wrapper ${activeShipmentIndex === index ? 'active' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveShipmentIndex((activeShipmentIndex === index) ? -1 : index);
              setIsSelected(true);
            }}
          >
            <div className='items-overlay'>
              <div className='items'>
                <p>{item.title}</p>
              </div>
              <div className='items'>
                <p>{item.locationCode}</p>
              </div>
            </div>
            <div className='items'>
              {(() => {

                let status = 'grey';
                if (item.currentProgress === 0) {
                  status = 'grey';
                } else if (item.totalProgress === item.currentProgress) {
                  status = 'success';
                } else if (item.currentProgress < item.totalProgress) {
                  status = 'warning';
                } else {
                  status = 'warning';
                }

                return (
                  <ProgressBar
                    status={status}
                    labelText="Status"
                    current={item.currentProgress} 
                    total={item.totalProgress}
                  />
                );
              })()}
            </div>
          </div>
        ))}
      </PackWrapper>
    </Spin>
  );
};

export default PackCard;
